import { ActivityBetConditionType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

export const activityBetConditionTypeName: { [key in ActivityBetConditionType]: TKeyType } = {
  [ActivityBetConditionType.SINGLE]: 'common.singleBetCash',
  [ActivityBetConditionType.ACCUMULATED]: 'common.accumulatedBetCash'
}

export default activityBetConditionTypeName
